var _templateObject, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgStudio = function SvgStudio(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9baac7",
    stroke: "currentColor",
    d: "M11.8.501h18.619l9.008 9.442v18.002H36.28l.138.61c.149.66.23 1.348.23 2.056 0 4.85-3.717 8.765-8.31 8.889H9.582L.5 30.056V11.979h3.145l-.138-.61a9.3 9.3 0 0 1-.23-2.056c0-4.775 3.602-8.636 8.086-8.807z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M29.363 30.66a1.56 1.56 0 0 1 1.783.968l-.642.246a.875.875 0 1 0 .029.54l.664.178a1.562 1.562 0 1 1-1.834-1.933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    fillRule: "evenodd",
    d: "M29.688 29.375a2.813 2.813 0 1 1 0 5.625 2.813 2.813 0 0 1 0-5.625m0 .619a2.193 2.193 0 1 0 0 4.387 2.193 2.193 0 0 0 0-4.387",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ab3a29",
    d: "M23.75 20.313A4.69 4.69 0 0 1 19.063 25H5v-9.375h5.625c1.726 0 3.125 1.4 3.125 3.125v1.875H15v-2.57a2.43 2.43 0 0 1 2.43-2.43h1.633a4.69 4.69 0 0 1 4.687 4.688m2.5-5.938h-6.875a3.125 3.125 0 0 1-3.125-3.125V9.375H15v1.875c0 1.726-1.4 3.125-3.125 3.125A4.375 4.375 0 0 1 7.5 10v-.625A4.375 4.375 0 0 1 11.875 5H26.25z"
  }))));
};
export default SvgStudio;